import { Box, Stack, TextField, Typography } from '@mui/material';

const weekdayOptions = [
    { key: 'mon', label: 'SEG' },
    { key: 'tue', label: 'TER' },
    { key: 'wed', label: 'QUA' },
    { key: 'thu', label: 'QUI' },
    { key: 'fri', label: 'SEX' },
    { key: 'sat', label: 'SAB' },
    { key: 'sun', label: 'DOM' }
];

const AvailabilityScheduleCard = ({
    title = '',
    activeDays = [],
    notes = '',
    editing = false,
    onToggleDay,
    onNotesChange
}) => {
    const showHeader = Boolean(title);

    return (
        <Box
            sx={{
                p: 2,
                borderRadius: '18px',
                bgcolor: '#FFFFFF',
                border: '1px solid #E5E5E5'
            }}
        >
            {showHeader ? (
                <Typography variant="body2" fontWeight={700} color="#3D3D3D" mb={1.2}>
                    {title}
                </Typography>
            ) : null}

            <Stack direction="row" spacing={0.8} flexWrap="wrap" useFlexGap mb={1.4}>
                {weekdayOptions.map((day) => {
                    const active = activeDays.includes(day.key);
                    return (
                        <Box
                            key={day.key}
                            component="button"
                            type="button"
                            onClick={() => onToggleDay?.(day.key)}
                            disabled={!editing}
                            sx={{
                                minWidth: 0,
                                px: 1.1,
                                py: 0.5,
                                borderRadius: '10px',
                                border: '1px solid',
                                fontWeight: 700,
                                fontSize: '0.74rem',
                                lineHeight: 1.2,
                                cursor: editing ? 'pointer' : 'default',
                                color: active ? '#FFFFFF' : '#5E5E5E',
                                bgcolor: active ? '#D63731' : '#FFFFFF',
                                borderColor: active ? '#D63731' : '#D9D9D9',
                                opacity: !editing ? 0.9 : 1,
                                transition: 'all 0.2s ease',
                                '&:hover': editing
                                    ? {
                                          bgcolor: active ? '#BF2F2A' : '#F7F7F7',
                                          borderColor: active ? '#BF2F2A' : '#D9D9D9'
                                      }
                                    : undefined
                            }}
                        >
                            {day.label}
                        </Box>
                    );
                })}
            </Stack>

            <TextField
                fullWidth
                multiline
                minRows={3}
                value={notes}
                onChange={(event) => onNotesChange?.(event.target.value.slice(0, 180))}
                disabled={!editing}
                placeholder="Adiciona notas breves sobre o horario."
                sx={{
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '14px',
                        bgcolor: '#FFFFFF'
                    }
                }}
            />
        </Box>
    );
};

export default AvailabilityScheduleCard;
